import { CheckboxFilter, OwnProps } from './checkbox';

export function NoHeaderFilter(props: OwnProps) {
  return <CheckboxFilter {...props} noHeader isOpen />;
}
